"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon/APIcon"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _kycConfigShapePropTypes = require("../../../propTypes/kycConfigShapePropTypes");
require("./KYCLevelComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var kycClasses = (0, _cssClassesHelper.getBEMClasses)('kyc-level');
var KYCLevelComponent = /*#__PURE__*/function (_React$Component) {
  function KYCLevelComponent() {
    _classCallCheck(this, KYCLevelComponent);
    return _callSuper(this, KYCLevelComponent, arguments);
  }
  _inherits(KYCLevelComponent, _React$Component);
  return _createClass(KYCLevelComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        verified = _this$props.verified,
        underReview = _this$props.underReview,
        canIncrease = _this$props.canIncrease,
        currentLevel = _this$props.currentLevel,
        openPane = _this$props.openPane,
        onSumSubClick = _this$props.onSumSubClick,
        highlightStyle = _this$props.highlightStyle,
        _this$props$config = _this$props.config,
        label = _this$props$config.label,
        button = _this$props$config.button,
        verifiedMessage = _this$props$config.verifiedMessage,
        underReviewMessage = _this$props$config.underReviewMessage,
        _this$props$config$de = _this$props$config.description,
        benefits = _this$props$config$de.benefits,
        requirements = _this$props$config$de.requirements;
      var activeCard = currentLevel ? "selected" : '';
      var onButtonClick = function onButtonClick() {
        return onSumSubClick ? onSumSubClick() : openPane();
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses(null, activeCard)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('header-title', activeCard)
      }, t(label)), highlightStyle === 'star' && currentLevel && /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "star",
        className: kycClasses('star-icon')
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('body')
      }, benefits && benefits.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('benefits')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('sub-title', activeCard)
      }, t("Benefits")), /*#__PURE__*/_react["default"].createElement("ul", {
        className: kycClasses('list')
      }, benefits.map(function (benefit, idx) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: idx,
          className: kycClasses('list-item')
        }, t(benefit));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('requirements')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('sub-title', activeCard)
      }, t("Requirements")), /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('item-description')
      }, t(requirements)))), verified && /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('footer', 'verified')
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "simple-check",
        customClass: kycClasses('verified-icon')
      }), t(verifiedMessage)), underReview && /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('footer', 'under-review')
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "pending",
        customClass: kycClasses('under-review-icon')
      }), t(underReviewMessage)), canIncrease && /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('footer', 'can-increase')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: kycClasses('change'),
        onClick: onButtonClick
      }, t(button) || t("Increase to {{label}}", {
        label: label
      }))), !verified && !underReview && !canIncrease && /*#__PURE__*/_react["default"].createElement("div", {
        className: kycClasses('footer', 'cannot-increase')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: kycClasses(),
        disabled: true,
        onClick: onButtonClick
      }, t(button) || t("Increase to {{label}}", {
        label: label
      }))));
    }
  }]);
}(_react["default"].Component);
KYCLevelComponent.propTypes = {
  verified: _propTypes["default"].bool,
  underReview: _propTypes["default"].bool,
  currentLevel: _propTypes["default"].bool,
  canIncrease: _propTypes["default"].bool,
  config: _propTypes["default"].shape(_kycConfigShapePropTypes.kycConfigLevelShape),
  openPane: _propTypes["default"].func,
  highlightStyle: _propTypes["default"].string
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("kyc")(KYCLevelComponent);